// extracted by mini-css-extract-plugin
export default {"title":"_ed9e4ca6"};